export default "__VITE_PUBLIC_ASSET__9c426e87__"